import serviceConnect from 'libs/servicesUtils'

function changePasswordService(params) {
  const url = `/password/update/`
  return serviceConnect.postService(url, params, {})
}

export default changePasswordService
